import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import type { GetInstallationSyncStatusResponse } from '@/types/installationSync';

const endpoint = `${apiUrl}getInstallationSyncStatus/`;

export const getInstallationSyncStatus = async (
  orgUUID: string
): Promise<GetInstallationSyncStatusResponse> => {
  const res = await postWithAuth(endpoint, { OrgUUID: orgUUID });
  const data = await res.json();
  return data;
};
